import React from 'react'
import PageForm from '../form'

const ReschedulePolicy = () => {
  return <PageForm title="Reschedule Policy" Key="reschedule-policy" />
}

export default ReschedulePolicy
